import { Sparkles } from 'lucide-react';
import { Screen } from '@m/ui/Screen';
import { Button, Empty } from '@m/ui/Controls';
import { openDesktop } from './labels';

/**
 * The Assistant's chat is not rebuilt for the phone yet: it streams tool
 * calls, renders server-built cards and asks before each write, all of which
 * live in web-v2's Assistant components. Until a phone version exists this
 * opens the full one.
 */
export function AssistantScreen() {
  return (
    <Screen title="Assistant" back="/more" backLabel="More">
      <Empty icon={<Sparkles />} title="Ask about your hours and invoices" body="The Assistant answers from your own records and can log time or draft invoices.">
        <Button onClick={() => openDesktop('/ai/assistant')}>Open the Assistant</Button>
      </Empty>
    </Screen>
  );
}
